import type { JSX } from 'react';

import { Container, Content, Spinner } from './Loading.styled';

type IProps = {
  loading?: boolean;
};

export default function Loading({ loading = false }: IProps): JSX.Element | null {
  if (!loading) return null;

  return (
    <Container data-testid="loading-component">
      <Content />
      <Spinner data-testid="loading-spinner" role="status" aria-label="Loading" />
    </Container>
  );
}
